<img
  [ngClass]="{ inplace: inplace }"
  src="/assets/cities/{{ arrivalAirport?.cityName?.toLowerCase() }}.webp"
  onerror="this.src='/assets/images/city.svg'"
  alt="city"
  class="picture"
/>

<div class="d-flex p-4 p-md-6">
  <div class="d-flex flex-column">
    <div class="mb-2">
      <lead-details-title
        [type]="tripType"
        [from]="departureAirport?.cityName"
        [to]="arrivalAirport?.cityName"
        textSize="medium"
      />
    </div>

    <lead-details-subtitle
      [departDate]="departureAt | date: 'EEE, MMM d'"
      [returnDate]="roundTripDepartureAt | date: 'EEE, MMM d'"
      [travelers]="totalPassengers"
      [from]="from"
    />

    @if (!inplace) {
      <div class="mt-4">
        @if (optionCount && minimalOptionPrice) {
          <p class="mb-1">
            {{ optionCount }} exclusive flight deals starting from
            {{ minimalOptionPrice | portalCurrency }}.
          </p>
        }
        @if (maximalSecureSavings) {
          <p class="text-green-800">
            You can save up to <span [innerHTML]="maximalSecureSavings | portalCurrency"></span> per
            person right now.
          </p>
        }
      </div>

      <ds-button
        [label]="optionCount ? 'Book now' : 'Go to quote'"
        size="m"
        class="mt-6"
        data-id="book"
      />
    }
  </div>

  @if (inplace) {
    <img
      src="/assets/icons/chevron_right.svg"
      alt="chevron_right"
      class="chevron"
      data-id="chevron"
    />
  }
</div>
